/**
 * 시스템 > 장비관리 > 장비검색 Store
 *
 * @since 2018-03-12
 * @author devp010
 * @since 2018-09-28
 * @modify devp018
 */
import {SystemApiPrefix as apiPrefix} from '~/utils/restApi'
export const state = () => ({
  BASE_URL: `${apiPrefix}/devices`,
  unReg: `${apiPrefix}/devices/unregistered`,
  deviceSearchDataList: [],
  orgDeviceSearchDataList: [],
  deviceSearchData: {
    use: 0,
    unreg_device_dir_type: 1, // 방향성 (1:정방향 , 0: 역방향)
    unreg_device_model_name: '100',
    unreg_device_ip: '192.168.174.41',
    unreg_device_model_type: 'NGFW',
    unreg_device_id: '',
    iGroup: 'GROUP 11',
    iGroupId: 2, // 장비 아이디 필수!
    unreg_device_login_id: 'ID명',
    unreg_device_login_pass: 'pass1234',
    unreg_device_mng_type: 1
  },
  // deviceSearchDataListKeyword: [],
  keyword: '',
  listSelectedDevice: void 0,
  loopCount: 1,
  maxLoopCount: 10000000, // 조회 수 설정, 요청에 의해 실질적인 무제한으로 설정
  status: 0, // 진행 상태 (0: 시작안함, 1: 검색중, 2: 완료)
  searchParam: {
    search_ip: '', // 조회 IP
    search_port: 443
  },
  progress_per: '0% [0/0]',
  selectedData: []
})

export const mutations = {
  resetDeviceSearchDataList (state) {
    state.deviceSearchDataList = []
    state.orgDeviceSearchDataList = []
    state.selectedData = []
    state.listSelectedDevice = void 0
  },
  onHeaderSelChange (state, payload) {
    const deviceSearchDataList = _.map(state.deviceSearchDataList, (info) => {
      info['use'] = payload
      if (payload === 0) {
        info['iGroup'] = ''
        info['iGroupId'] = void 0
        info['unreg_device_login_id'] = ''
        info['unreg_device_login_pass'] = ''
        info['unreg_device_mng_type'] = 1
      }
      return info
    })

    state.deviceSearchDataList = Object.freeze(deviceSearchDataList)
    // state.selectedData = []
  },
  onSelChange (state, { value, item } = {}) {
    let deviceSearchDataList = []

    const
      isExist = _.get(state.selectedData, ['length'], 0) > 0,
      isSelectedItem = !_.isEmpty(_.filter(state.selectedData, r => r.unreg_device_id === item.unreg_device_id))

    if (isExist && isSelectedItem) {
      const unregDeviceMap = _.map(state.selectedData, 'unreg_device_id')
      deviceSearchDataList = _.map(state.deviceSearchDataList, (info) => {
        const isCond = unregDeviceMap.indexOf(info.unreg_device_id) !== -1 || item.unreg_device_id === info.unreg_device_id
        if (isCond && info['use'] !== value) {
          info['use'] = value
          if (value === 0) {
            info['iGroup'] = ''
            info['iGroupId'] = void 0
            info['unreg_device_login_id'] = ''
            info['unreg_device_login_pass'] = ''
            info['unreg_device_mng_type'] = 1
          }
        }
        return info
      })
    } else {
      deviceSearchDataList = _.map(state.deviceSearchDataList, (info) => {
        const isCond = info.unreg_device_id === item.unreg_device_id
        if (isCond && info['use'] !== value) {
          info['use'] = value
          if (value === 0) {
            info['iGroup'] = ''
            info['iGroupId'] = void 0
            info['unreg_device_login_id'] = ''
            info['unreg_device_login_pass'] = ''
            info['unreg_device_mng_type'] = 1
          }
        }
        return info
      })
    }

    state.deviceSearchDataList = Object.freeze(deviceSearchDataList)
  },
  onHeaderMonitoringChange (state, payload) {
    const deviceSearchDataList = _.map(state.deviceSearchDataList, (info) => {
      if (info.use === 1) {
        info['unreg_device_mng_type'] = payload
      }
      return info
    })

    state.deviceSearchDataList = Object.freeze(deviceSearchDataList)
    // state.selectedData = []
  },
  onMonitoringChange (state, { value, item } = {}) {
    let deviceSearchDataList = []

    const
      isExist = _.get(state.selectedData, ['length'], 0) > 0,
      isSelectedItem = !_.isEmpty(_.filter(state.selectedData, r => r.unreg_device_id === item.unreg_device_id))

    if (isExist && isSelectedItem) {
      const unregDeviceMap = _.map(state.selectedData, 'unreg_device_id')
      deviceSearchDataList = _.map(state.deviceSearchDataList, info => {
        const isCond = (unregDeviceMap.indexOf(info.unreg_device_id) !== -1 || info.unreg_device_id === item.unreg_device_id) && info.use === 1
        if (isCond && info['unreg_device_mng_type'] !== value) {
          info['unreg_device_mng_type'] = value
        }
        return info
      })
    } else {
      deviceSearchDataList = _.map(state.deviceSearchDataList, info => {
        if (info.unreg_device_id === item.unreg_device_id && info['unreg_device_mng_type'] !== value) {
          info['unreg_device_mng_type'] = value
        }
        return info
      })
    }

    state.deviceSearchDataList = Object.freeze(deviceSearchDataList)
    // state.selectedData = []
  },
  // dataTable 에서 선택된 장비 : 직접적으로 state로 접근 비추
  setSelectedDevice (state, val) {
    state.listSelectedDevice = val
  },
  // 장비트리에서 장비노드 선택 시
  updateDevice (state, obj) {
    let newList = []

    const
      isExist = _.get(state.selectedData, ['length'], 0) > 0,
      isSelectedItem = !_.isEmpty(_.filter(state.selectedData, r => r.unreg_device_id === state.listSelectedDevice))

    if (isExist && isSelectedItem) {
      const unregDeviceMap = _.map(state.selectedData, 'unreg_device_id')
      newList = _.map(state.deviceSearchDataList, item => {
        const isCond = unregDeviceMap.indexOf(item.unreg_device_id) !== -1 && item.use === 1
        const isCondGroup = item['iGroup'] !== obj.device_uname || item['iGroupId'] !== obj.device_id
        if (isCond && isCondGroup) {
          item['iGroup'] = obj.device_uname
          item['iGroupId'] = obj.device_id
        }
        return item
      })
    } else {
      newList = _.map(state.deviceSearchDataList, item => {
        const isCond = item.unreg_device_id === state.listSelectedDevice
        const isCondGroup = item['iGroup'] !== obj.device_uname || item['iGroupId'] !== obj.device_id
        if (isCond && isCondGroup) {
          item['iGroup'] = obj.device_uname
          item['iGroupId'] = obj.device_id
        }
        return item
      })
    }

    state.deviceSearchDataList = Object.freeze(newList)
    // state.selectedData = []
    state.listSelectedDevice = void 0
  },
  setDeviceSearchDataList (state, payload) {
    const deviceSearchDataList = _.map(payload, items => {
      items.use = 0
      items['iGroup'] = ''
      items['iGroupId'] = void 0
      items['unreg_device_login_id'] = ''
      items['unreg_device_login_pass'] = ''
      // items['unreg_device_mng_type'] = 1
      return items
    })

    state.deviceSearchDataList = Object.freeze(deviceSearchDataList)
    state.orgDeviceSearchDataList = _.cloneDeep(state.deviceSearchDataList)
    // state.selectedData = []
  },
  tossResult (state, payload) {
    state.status = payload.status
    state.searchParam.search_ip = payload.search_ip
    state.searchParam.search_port = _.isNull(payload.search_port) ? 443 : payload.search_port
    state.progress_per = payload.progress_per
  },
  // 결과 출력
  setResult (state, payload) {
    if (!payload) return
    if (!payload.result) return
    if (payload.code === 'async' && payload.result.status === 'SUCCESS' && payload.result.attributes.length > 0) {
      const deviceSearchDataList = []
      const arrObj = payload.result.attributes
      const arrObjLen = arrObj.length
      for (let i = 0; i < arrObjLen; i++) {
        const obj = arrObj[i]
        if (obj.msg === 'ok') {
          obj['use'] = 0 // 체크 안됨으로 초기화
          obj['unreg_device_mng_type'] = 1 // 체크 안됨으로 초기화
          obj['iGroup'] = ''
          obj['iGroupId'] = void 0
          obj['unreg_device_login_id'] = ''
          obj['unreg_device_login_pass'] = ''
          obj['iInterface'] = ''
          deviceSearchDataList.push(obj)
        }
      }

      state.deviceSearchDataList = Object.freeze(deviceSearchDataList)
      state.orgDeviceSearchDataList = _.cloneDeep(state.deviceSearchDataList)

      // state.selectedData = []
    }
  },
  resetSelectedData (state) {
    state.selectedData = []
  },
  setSelectedData (state, payload) {
    state.selectedData = payload
  },
  setUnregDeviceLoginId (state, { value, item } = {}) {
    let deviceSearchDataList = []

    const
      isExist = _.get(state.selectedData, ['length'], 0) > 0,
      isSelectedItem = !_.isEmpty(_.filter(state.selectedData, r => r.unreg_device_id === item.unreg_device_id))

    if (isExist && isSelectedItem) {
      const unregDeviceMap = _.map(state.selectedData, 'unreg_device_id')
      deviceSearchDataList = _.map(state.deviceSearchDataList, info => {
        const isCond = (unregDeviceMap.indexOf(info.unreg_device_id) !== -1 || info.unreg_device_id === item.unreg_device_id) && info.use === 1
        if (isCond && info['unreg_device_login_id'] !== value) {
          info['unreg_device_login_id'] = value
        }
        return info
      })
    } else {
      deviceSearchDataList = _.map(state.deviceSearchDataList, info => {
        const isCond = info.unreg_device_id === item.unreg_device_id
        if (isCond && info['unreg_device_login_id'] !== value) {
          info['unreg_device_login_id'] = value
        }
        return info
      })
    }

    state.deviceSearchDataList = Object.freeze(deviceSearchDataList)
    // state.selectedData = []
  },
  setUnregDeviceLoginPwd (state, { value, item } = {}) {
    let deviceSearchDataList = []

    const
      isExist = _.get(state.selectedData, ['length'], 0) > 0,
      isSelectedItem = !_.isEmpty(_.filter(state.selectedData, r => r.unreg_device_id === item.unreg_device_id))

    if (isExist && isSelectedItem) {
      const unregDeviceMap = _.map(state.selectedData, 'unreg_device_id')
      deviceSearchDataList = _.map(state.deviceSearchDataList, info => {
        const isCond = (unregDeviceMap.indexOf(info.unreg_device_id) !== -1 || info.unreg_device_id === item.unreg_device_id) && info.use === 1
        if (isCond && info['unreg_device_login_pass'] !== value) {
          info['unreg_device_login_pass'] = value
        }
        return info
      })
    } else {
      deviceSearchDataList = _.map(state.deviceSearchDataList, info => {
        const isCond = info.unreg_device_id === item.unreg_device_id
        if (isCond && info['unreg_device_login_pass'] !== value) {
          info['unreg_device_login_pass'] = value
        }
        return info
      })
    }

    state.deviceSearchDataList = Object.freeze(deviceSearchDataList)
    // state.selectedData = []
  }
}

export const actions = {
  // acsSearchDataList ({commit, state}) {
  //   commit('acsSearchDataList', state.keyword)
  // },
  async searchStop ({state}) {
    const res = await this.$axios.$put(`${state.BASE_URL}/search/stop`, void 0, { loading: false, loadingHide: false, successAlert: false })
    return res
  },
  // ######################################################
  //  탐색 : api 연동, 1차 아이디 추출
  // ======================================================
  async onIpSubmit ({commit, state}, payload) {
    const res = await this.$axios.$post(`${state.BASE_URL}/search`, payload, {successAlert: false}) // loading: false, loadingHide: false,
    if (res.code !== 'ok') {
      commit('resetDeviceSearchDataList')
    }

    return res
  },
  // ######################################################
  //  저장 : api 연동, 2차 결과 추출
  // ======================================================
  async getStatus ({commit, state}) {
    const res = await this.$axios.$get(`${state.unReg}/status`, { loading: false, loadingHide: false })
    if (res.code === 'ok') {
      commit('tossResult', res.result)
    } else {
      commit('resetDeviceSearchDataList')
    }
    return res
  },
  async getList ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      res = await this.$axios.$get(state.unReg, {loading: false, loadingHide: false})

      if (res.code === 'ok') {
        commit('setDeviceSearchDataList', res.result)
      } else {
        commit('resetDeviceSearchDataList')
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async getResult ({commit, state}, payload) {
    const res = await this.$axios.$get(`/api/sm/devices/search/progress/${payload.result.id}`, { loading: false, loadingHide: false })
    if (res.code === 'async') {
      if (res.result.status === 'SUCCESS') {
        commit('setResult', res)
      } else {
        commit('tossResult', res)
      }
    } else {
      commit('resetDeviceSearchDataList')
    }
    return res
  },
  // ######################################################
  //  저장 : api 연동, 적용 저장
  // ======================================================
  async saveDataTable ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const saveData = []
      _.forEach(state.deviceSearchDataList, row => {
        if (row.use) {
          saveData.push({
            unreg_device_id: row.unreg_device_id,
            unreg_device_login_id: row.unreg_device_login_id,
            unreg_device_login_pass: btoa(row.unreg_device_login_pass),
            unreg_parent_group_id: row.iGroupId,
            unreg_device_mng_type: row.unreg_device_mng_type
          })
        }
      })
      const params = {
        apply_list: saveData
      }

      res = await this.$axios.$post(`${state.BASE_URL}/register/list`, params)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async finalCommand ({state}, type) {
    const axiosConfig = (type === 'apply') ? { applyMsg: true } : { cancelMsg: true }
    const res = await this.$axios.$put(`${state.unReg}/${type}`, void 0, axiosConfig)
    return res
  }
}

export const getters = {}

export const strict = false
